import { render } from "./FormCompleteHeader.vue?vue&type=template&id=c8437498&scoped=true"
import script from "./FormCompleteHeader.vue?vue&type=script&lang=js"
export * from "./FormCompleteHeader.vue?vue&type=script&lang=js"

import "./FormCompleteHeader.vue?vue&type=style&index=0&id=c8437498&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/osod-form/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8437498"]])

export default __exports__